import script from "./TheFooterComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheFooterComponent.vue?vue&type=script&lang=ts&setup=true"

import "./TheFooterComponent.vue?vue&type=style&index=0&id=6a957669&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a957669"]])

export default __exports__